/** @format */

import {ArrowCircleUpIcon} from '@heroicons/react/solid'
import clsx from 'clsx'
import React, {ComponentPropsWithoutRef, PropsWithChildren} from 'react'

import {useMinimumUpgradeProduct} from '@src/contexts'

import {UpgradeLink} from './UpgradeLink'

type UpgradeMessageProps = PropsWithChildren<{
  // align the upgrade button to the start or end of the container
  alignButton?: 'start' | 'end'
  // legacy: to display after "Requires Upgrade" message
  plan?: string
  title?: string
}> &
  Omit<ComponentPropsWithoutRef<typeof UpgradeLink>, 'className'>

export function UpgradeMessage(props: UpgradeMessageProps) {
  const {
    alignButton = 'start',
    children,
    plan,
    title,
    ...upgradeLinkProps
  } = props
  const product = useMinimumUpgradeProduct(upgradeLinkProps.feature)
  const planName = plan ?? product?.name
  return (
    <div className="flex flex-col items-start gap-y-4">
      {title && <h3>{title}</h3>}
      <p className="flex items-center gap-x-1 font-semibold text-gray-700">
        <ArrowCircleUpIcon className="h-5 w-5 text-blue-700" />
        <span>Requires Upgrade</span>
        {planName && <span> to {planName}</span>}
      </p>
      {children && <p>{children}</p>}
      <UpgradeLink
        {...upgradeLinkProps}
        className={clsx('buttonPrimary', alignButton === 'end' && 'self-end')}
      >
        {product ? `Upgrade to ${product.name}` : 'Upgrade'}
      </UpgradeLink>
    </div>
  )
}
